import React from "react";
import Button from "./Button";

export function CreateUsedDealButton({ onClick, disabled }) {
  return (
    <Button
      type="basic"
      label="In-stock car"
      size="medium"
      disabled={disabled}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
